module.exports = __webpack_public_path__ + "img/goinbox.08114e57.svg";